import styles from "./styles.scss";

export const getAvatarBackground = (name: string) => {
  const firstLetter = name.slice(0, 1).toLowerCase().charCodeAt(0);

  const ranges = [
    ["a", "d"],
    ["e", "h"],
    ["i", "l"],
    ["m", "p"],
    ["q", "t"],
    ["u", "w"],
    ["x", "z"],
  ];

  const index = ranges.findIndex(
    ([start, end]) =>
      firstLetter >= start.charCodeAt(0) && firstLetter <= end.charCodeAt(0),
  );

  const backgrounds = [
    styles.pacific,
    styles.purple,
    styles.orange,
    styles.electric,
    styles.supernova,
    styles.blue,
    styles.green,
  ];

  const backgroundIndex = index !== -1 ? index : backgrounds.length - 1;

  return backgrounds[backgroundIndex];
};
